import styled from 'styled-components'

export const Button = styled.div`
  width: 190px;
  color: white;
  margin: 10px 25px 10px 25px;
  height: 190px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  border: 1px solid #bfbfbf;
  border-radius: 3px;
  cursor: pointer;
  box-shadow: 3px 3px 5px 0px rgba(0, 0, 0, 0.75);
  transition: box-shadow 0.1s ease-in-out;
  &:hover {
    box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.75);
  }
`
